export { default as FavoritesList } from './component';
